<template>
  <section class="myhome-con"
           v-if="isInit">
    <div class="tit-box type1">
      <h1 class="tit-type1">1:1 문의 작성</h1>
      <div>
        <btn :txt="'저장'"
             :size="'small'"
             :color="'purple'"
             @click="btnSave_click"/>
        <btn :txt="'취소'"
             :size="'small'"
             :color="'white'"
             @click="btnCancl_click"/>
      </div>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:15%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>시설</th>
        <td class="last">
          {{ fcltyNm }}
          <btn v-if="isFcltyChocPsbl"
               :txt="'선택'"
               :size="'ssmall'"
               :color="'white'"
               @click="btnFcltyChoc_click"/>
        </td>
      </tr>
      <tr>
        <th>구분</th>
        <td class="last">
          <cd-selbx :is-select="true"
                    :cds="dirctInqryTycds"
                    :cd="dirctInqryTycd"
                    @select="selbxDirctInqryTycd_select"/>
        </td>
      </tr>
      <tr>
        <th>제목</th>
        <td class="last">
          <input type="text"
                 style="width: 100%"
                 maxlength="200"
                 v-model="bbstSj"/>
        </td>
      </tr>
      <tr>
        <th>내용</th>
        <td class="last">
          <editor ref="dirctInqryEditor"
                  :height="'300px'"/>
        </td>
      </tr>
      <tr>
        <th>첨부파일</th>
        <td class="last">
          <multi-file-upload
                  :max-cnt="3"
                  :max-size="10"
                  @change="tcflUpld_change"
                  @delete="tcflUpld_delete"/>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref} from 'vue';
import {getStore, getUtils} from "@/utils/import";

const {$cd, $alert, $axios, $cmmn, $cmmnPopup} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: false,
  }
})

const dirctInqryTycds = ref([]);
const dirctInqryTycd = ref('');
const bbstSj = ref('');
const fcltySn = ref();
const fcltyNm = ref();
const isFcltyChocPsbl = ref(true);

const selbxDirctInqryTycd_select = (selCd) => {
  dirctInqryTycd.value = selCd;
}

const btnFcltyChoc_click = () => {
  $cmmnPopup.fcltyChocShow(fcltyChoc);
}

const fcltyChoc = ({fcltySn: setFcltySn, fcltyNm: setFcltyNm}) => {
  fcltySn.value = setFcltySn;
  fcltyNm.value = setFcltyNm;
}

const tcfls = ref([]);
const tcflUpld_change = async (fileInfos) => {
  fileInfos.forEach((file) => file.bbstFileSecd = '400');
  tcfls.value = tcfls.value.concat(fileInfos);
}

const tcflUpld_delete = async ({index}) => {
  tcfls.value.splice(index, 1);
}

const valid = () => {
  let isValid = true;
  let msg = '';

  if (isValid && !dirctInqryTycd.value) {
    isValid = false;
    msg = '1:1 문의 분류를 선택해주세요.';
  }

  if (isValid && !bbstSj.value) {
    isValid = false;
    msg = '제목을 입력해주세요.';
  }

  const {cn} = dirctInqryEditor.value.getCnAndFiles();
  const isInputCn = cn && cn != '<p><br></p>';
  if (isValid && !isInputCn) {
    isValid = false;
    msg = '내용을 입력해주세요.';
  }

  return {isValid, msg};
}

const dirctInqryEditor = ref(null);
const btnSave_click = async () => {
  try {
    $loading.on();

    let {cn, upldCnImgFils} = dirctInqryEditor.value.getCnAndFiles();
    upldCnImgFils.forEach((file) => {
      file.bbstFileSecd = '700';
      cn = cn.replaceAll(file.dwldUrl, file.flnm);
    });

    const {isValid, msg} = valid();

    if (!isValid) {
      await $alert(msg);
      return false;
    }

    const upldFiles = tcfls.value.concat(upldCnImgFils);
    const registerParams = {
      mberSn: $mber.mberSn,
      fcltySn: fcltySn.value,
      dirctInqryTycd: dirctInqryTycd.value,
      bbstSj: bbstSj.value,
      bbstCn: cn,
      files: upldFiles
    }

    await registerDirctInqry(registerParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const registerDirctInqry = async ({mberSn, fcltySn, dirctInqryTycd, bbstSj, bbstCn, files}) => {
  const {data} = await $axios.post('/api/cscr/dirct-inqry', {mberSn, fcltySn, dirctInqryTycd, bbstSj, bbstCn, files});

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  moveList();
}

const emits = defineEmits(['chng-mode']);
const btnCancl_click = () => {
  moveList();
}

const moveList = () => {
  emits('chng-mode', {mode: 'list'});
}


const isInit = ref(false);
const init = async () => {
  const cds = await $cd.getCmmnCds('CMM1026');
  dirctInqryTycds.value = cds;

  if (props.fcltySn) {
    const setFcltyNm = await $cmmn.fclty.getFcltyNmByFcltySn(props.fcltySn);
    fcltyNm.value = setFcltyNm;
    fcltySn.value = props.fcltySn;
    isFcltyChocPsbl.value = false;
  }

  isInit.value = true;
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
